// product Make Offer button
$(".show_makeOffer").click(function() {
    $(".makeOffer_popups").css("display","flex")
    if (typeof window.syncMakeOfferPopup === 'function') {
        window.syncMakeOfferPopup();
    }
    gtag('event', 'cs_make_offer_click', {send_to: "G-4EMR07EYMC"});
})
$(".makeOffer_popups .offer-form-container .close").click(function(){
    $(".makeOffer_popups").fadeOut(300)
})

// product addCart tips text
$(".cs_shop_click_text").click(function(){
    $(".cs_shop_click_popups").css("display","flex")
})
$(".cs_shop_click_popups section span").click(function(){
    $(".cs_shop_click_popups").fadeOut(300)
})

// Sold-out recommendations vs shipping insurance (main PDP variant changes)
function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    var fmt = window.theme && window.theme.settings && window.theme.settings.money_with_currency_format;
    return Shopify.formatMoney(cents, fmt);
  }
  return (cents / 100).toFixed(2);
}

function fitSoldOutRecSelectWidth(selectEl) {
  if (!selectEl || !selectEl.options.length) return;

  var body = selectEl.closest('.cs-sold-out-rec__body');
  if (!body) return;

  var maxWidth = body.clientWidth;
  if (maxWidth <= 0) return;

  var measure = document.createElement('span');
  measure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
  measure.style.font = window.getComputedStyle(selectEl).font;
  measure.textContent = selectEl.options[selectEl.selectedIndex].textContent.trim();
  document.body.appendChild(measure);

  var textWidth = measure.offsetWidth;
  document.body.removeChild(measure);

  var chevronGap = 14;
  var selectWidth = Math.min(textWidth + chevronGap, maxWidth);
  selectEl.style.maxWidth = maxWidth + 'px';
  selectEl.style.width = Math.max(selectWidth, 48) + 'px';
}

function openSoldOutRecSelect(select) {
  if (!select) return;
  try {
    if (typeof select.showPicker === 'function') {
      select.showPicker();
      return;
    }
  } catch (err) {
    /* showPicker may throw if not in user gesture on some browsers */
  }
  select.focus({ preventScroll: true });
  select.click();
}

function initSoldOutRecVariantPickers() {
  document.querySelectorAll('.cs-sold-out-rec__variant-chevron').forEach(function (chevron) {
    chevron.addEventListener('mousedown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var label = chevron.closest('label.cs-sold-out-rec__variant');
      openSoldOutRecSelect(label && label.querySelector('select'));
    });
    chevron.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  document.querySelectorAll('label.cs-sold-out-rec__variant').forEach(function (label) {
    label.addEventListener('click', function (e) {
      if (e.target.tagName === 'SELECT') return;
      if (e.target.classList.contains('cs-sold-out-rec__variant-chevron')) return;
      e.preventDefault();
      openSoldOutRecSelect(label.querySelector('select'));
    });
  });
}

function getSoldOutRecVariants(card) {
  if (!card) return null;
  if (card._csSoldOutRecVariants) return card._csSoldOutRecVariants;
  var dataEl = card.querySelector('[data-cs-sold-out-rec-variants]');
  if (!dataEl) return null;
  try {
    card._csSoldOutRecVariants = JSON.parse(dataEl.textContent);
    return card._csSoldOutRecVariants;
  } catch (err) {
    return null;
  }
}

function getSoldOutRecVariantImageUrl(variant, fallbackUrl) {
  if (variant) {
    var preview = variant.featured_media && variant.featured_media.preview_image;
    if (preview && preview.src) return preview.src;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
  }
  return fallbackUrl || '';
}

function setSoldOutRecImage(card, imageUrl) {
  if (!card || !imageUrl) return;
  var imageEl = card.querySelector('.cs-sold-out-rec__img');
  if (!imageEl) {
    var mediaLink = card.querySelector('[data-cs-sold-out-rec-media]');
    imageEl = mediaLink && mediaLink.querySelector('img');
  }
  if (!imageEl) return;

  imageEl.classList.remove('lazyload', 'lazyloading');
  imageEl.classList.add('lazyloaded');
  imageEl.src = imageUrl;
  imageEl.srcset = imageUrl + ' 240w';
  imageEl.setAttribute('data-srcset', imageUrl + ' 240w');
}

function updateSoldOutRecCard(selectEl) {
  var formId = selectEl.getAttribute('data-rec-form');
  var form = document.getElementById(formId);
  if (!form) return;

  var option = selectEl.options[selectEl.selectedIndex];
  var variantId = selectEl.value;
  var price = option.getAttribute('data-price');
  var compareAt = option.getAttribute('data-compare-at');
  var idInput = form.querySelector('input[name="id"]');
  var addBtn = form.querySelector('[name="add"]');

  if (idInput) idInput.value = variantId;

  var card = selectEl.closest('.cs-sold-out-rec__card');
  if (card) {
    var variants = getSoldOutRecVariants(card);
    var variantIdNum = parseInt(variantId, 10);
    var variantData = variants && variants.find(function (v) {
      return v.id === variantIdNum;
    });
    var fallbackUrl = card.getAttribute('data-fallback-image') || option.getAttribute('data-image');
    var imageUrl = getSoldOutRecVariantImageUrl(variantData, fallbackUrl);
    setSoldOutRecImage(card, imageUrl);
  }
  var priceWrap = card && card.querySelector('[data-cs-sold-out-rec-price] .price');
  if (priceWrap && price) {
    var html = '<ins><span class="amount">' + formatMoney(parseInt(price, 10)) + '</span></ins>';
    if (compareAt && parseInt(compareAt, 10) > parseInt(price, 10)) {
      html += '<del><span class="amount">' + formatMoney(parseInt(compareAt, 10)) + '</span></del>';
    }
    priceWrap.innerHTML = html;
  }

  if (addBtn) {
    if (option.disabled) {
      addBtn.setAttribute('disabled', 'disabled');
    } else {
      addBtn.removeAttribute('disabled');
    }
  }

  fitSoldOutRecSelectWidth(selectEl);
}

function resyncSoldOutRecCardsFromSelects() {
  document.querySelectorAll('.cs-sold-out-rec__variant-select').forEach(function (selectEl) {
    updateSoldOutRecCard(selectEl);
  });
}

function syncSoldOutRecommendationsVisibility() {
  var recs = document.querySelector('[data-cs-sold-out-recs]');
  var insurance = document.querySelector('[data-cs-shop-insurance]');
  var shipping = document.querySelector('.shippingDescription');
  if (!recs && !insurance) return;

  var addBtn = document.getElementById('AddToCart');
  var isSoldOut = addBtn && addBtn.hasAttribute('disabled');

  if (recs) {
    recs.hidden = !isSoldOut;
  }
  if (insurance) {
    insurance.hidden = isSoldOut;
  }
  if (shipping) {
    if (recs && isSoldOut) {
      shipping.classList.add('shippingDescription--no-top-border');
    } else {
      shipping.classList.remove('shippingDescription--no-top-border');
    }
  }

  if (recs && isSoldOut) {
    window.setTimeout(function () {
      document.querySelectorAll('.cs-sold-out-rec__variant-select').forEach(fitSoldOutRecSelectWidth);
    }, 50);
  }
}

function initSoldOutRecForms() {
  document.querySelectorAll('.cs-sold-out-rec__form form').forEach(function (form) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.disabled = false;
  });
}

function initSoldOutRecommendations() {
  document.querySelectorAll('.cs-sold-out-rec__variant-select').forEach(function (selectEl) {
    fitSoldOutRecSelectWidth(selectEl);
    selectEl.addEventListener('change', function () {
      updateSoldOutRecCard(selectEl);
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.cs-sold-out-rec__variant-select').forEach(fitSoldOutRecSelectWidth);
  });

  document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) {
    el.addEventListener('change', function () {
      window.setTimeout(syncSoldOutRecommendationsVisibility, 350);
    });
  });

  initSoldOutRecForms();
  initSoldOutRecVariantPickers();
  syncSoldOutRecommendationsVisibility();
  resyncSoldOutRecCardsFromSelects();

  window.addEventListener('pageshow', function () {
    resyncSoldOutRecCardsFromSelects();
    syncSoldOutRecommendationsVisibility();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSoldOutRecommendations);
} else {
  initSoldOutRecommendations();
}